var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRus(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    id: "ru",
    x: 1269,
    y: 655,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.941-8.059-18-18-18S0 8.059 0 18s8.059 18 18 18 18-8.059 18-18z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "bfa",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.941-8.059-18-18-18S0 8.059 0 18s8.059 18 18 18 18-8.059 18-18z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bfa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0v12h36V0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 12H0v12h36V12z",
    fill: "#4C9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 24H0v12h36V24z",
    fill: "#D0021B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35 18c0-9.389-7.611-17-17-17S1 8.611 1 18s7.611 17 17 17 17-7.611 17-17z",
    stroke: "#000"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAzNiAzNiIgaWQ9InJ1IiB4PSIxMjY5IiB5PSI2NTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2IDE4YzAtOS45NDEtOC4wNTktMTgtMTgtMThTMCA4LjA1OSAwIDE4czguMDU5IDE4IDE4IDE4IDE4LTguMDU5IDE4LTE4eiIgZmlsbD0iI2ZmZiIvPjxtYXNrIGlkPSJiZmEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiI+PHBhdGggZD0iTTM2IDE4YzAtOS45NDEtOC4wNTktMTgtMTgtMThTMCA4LjA1OSAwIDE4czguMDU5IDE4IDE4IDE4IDE4LTguMDU5IDE4LTE4eiIgZmlsbD0iI2ZmZiIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2JmYSkiPjxwYXRoIGQ9Ik0zNiAwSDB2MTJoMzZWMHoiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNMzYgMTJIMHYxMmgzNlYxMnoiIGZpbGw9IiM0QzlERkYiLz48cGF0aCBkPSJNMzYgMjRIMHYxMmgzNlYyNHoiIGZpbGw9IiNEMDAyMUIiLz48cGF0aCBvcGFjaXR5PSIuMSIgZD0iTTM1IDE4YzAtOS4zODktNy42MTEtMTctMTctMTdTMSA4LjYxMSAxIDE4czcuNjExIDE3IDE3IDE3IDE3LTcuNjExIDE3LTE3eiIgc3Ryb2tlPSIjMDAwIi8+PC9nPjwvc3ZnPgo=";
export { SvgRus as ReactComponent };